import mapboxgl from 'mapbox-gl';

export const disableMap = (map: mapboxgl.Map) => {
    map.dragPan.disable();
    map.dragRotate.disable();
    map.touchPitch.disable();
    map.touchZoomRotate.disable();
    map.keyboard.disable();
    map.doubleClickZoom.disable();
    map.scrollZoom.disable();
};

export const enableMap = (map: mapboxgl.Map) => {
    map.dragPan.enable();
    map.dragRotate.enable();
    map.touchPitch.enable();
    map.touchZoomRotate.enable();
    map.keyboard.enable();
    map.doubleClickZoom.enable();
    map.scrollZoom.enable();
};
